<script setup lang="ts">
  import { computed } from 'vue'
  import { useEventStore } from '@/stores/EventStore'
  import AvatarOrInitials from './AvatarOrInitials.vue'

  const eventStore = useEventStore()

  interface Props {
    hasClockStatusIndicator?: boolean
    employeeId?: number
  }

  const props = withDefaults(defineProps<Props>(), {
    hasClockStatusIndicator: true,
    employeeId: undefined,
  })

  const isClockedIn = computed(() =>
    eventStore.employeeIsClockedIn(props.employeeId),
  )
</script>
<template>
  <div
    appium="profilePicture"
    class="rounded-full border-2 relative cursor-pointer"
    :class="{
      'border-secondary': props.hasClockStatusIndicator && isClockedIn,
      'border-white': props.hasClockStatusIndicator && !isClockedIn,
    }"
  >
    <avatar-or-initials :employee-id="employeeId" />
  </div>
</template>
<style scoped>
  #rotate-icon {
    margin-top: 1px;
    animation: spin 0.8s linear forwards infinite;
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
